/* eslint-disable no-nested-ternary */

import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent, SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { KanbanComponent } from '@syncfusion/ej2-react-kanban';
import { Query } from '@syncfusion/ej2-data';
import { format, parseISO } from 'date-fns';
import {
  ColumnsDirective,
  ColumnDirective,
} from '@syncfusion/ej2-react-grids';
import { useStateContext } from '../contexts/ContextProvider';
// import compliance from '../data/compliance-2.png';
// import complianceOFF from '../data/compliance-3.png';

const ReportCard = ({ dt }) => {
  const { changeAssociate, setChangeAssociate } = useStateContext();
  const [riskData, setRiskData] = useState([]);
  const myData = [];
  const { associates, triage } = dt;
  if (associates) {
    associates.forEach((associate) => {
      if (!associate.risk || associate.risk === '' || !associate.name || associate.name === '') {
        const nonreporting = { status: 'nonreporting', id: associate._id, organization: associate.organization, associate };
        myData.push(nonreporting);
      } else if (associate.risk < 0) {
        const hypo = { status: 'hypo', id: associate._id, organization: associate.organization, associate };
        myData.push(hypo);
      } else if (associate.risk < 25) {
        const baseline = { status: 'baseline', id: associate._id, organization: associate.organization, associate };
        myData.push(baseline);
      } else if (associate.risk < 50) {
        const moderate = { status: 'moderate', id: associate._id, organization: associate.organization, associate };
        myData.push(moderate);
      } else if (associate.risk < 80) {
        const elevated = { status: 'elevated', id: associate._id, organization: associate.organization, associate };
        myData.push(elevated);
      } else {
        const severe = { status: 'severe', id: associate._id, organization: associate.organization, name: associate.name, associate };
        myData.push(severe);
      }
    });
  }
  useEffect(() => {
    setRiskData(myData);
    return () => {
      setRiskData([]);
    };
  }, [dt]);

  let kanbanObj;
  let textBoxObj;

  const columnTemplate = (props) => (
    <div className="header-template-wrap">
      <div className={`header-icon e-icons ${props.keyField}`} />
      <div className="header-text">{props.headerText}</div>
      <div className="item-count">&nbsp;&nbsp;&nbsp;{props.count} items</div>
    </div>
  );
  const cardClick = (args) => {
    // 'args.data' is the object representing the clicked card's data.
    // 'args.element' is the DOM element of the card.
    if (triage) {
      setChangeAssociate(args.data.associate._id);
    }
    // eslint-disable-next-line no-param-reassign
    args.cancel = true;
  };

  function cardTemplate(props) {
    let brdr = '2px solid darkgrey';
    let bg = 'rgba(128, 128, 128, 0.5);'; /* 50% opaque grey background */
    switch (props.status) {
      case 'hypo':
        brdr = '2px solid 0251cc';
        bg = '#0251cc19';
        break;
      case 'baseline':
        brdr = '2px solid #19e14b';
        bg = '#19e14b19';
        break;
      case 'moderate':
        brdr = '2px solid #ecec11';
        bg = '#ecec1119';
        break;
      case 'elevated':
        brdr = '2px solid #ea9713';
        bg = '#ea971319';
        break;
      case 'severe':
        brdr = '2px solid #f30707';
        bg = '#f3070719';
        break;
      case 'nonreporting':
        brdr = '2px solid #ced1d6';
        bg = '#ced1d619';
        break;
      default:
        break;
    }
    return (
      <div id={props.associate._id} className="card-template" style={{ height: '380px', marginBottom: '2' }}>
        <div
          style={{
            border: brdr,
            position: 'absolute',
            backgroundColor: bg,
            zIndex: 1,
            top: 2,
            marginBottom: 'auto',
            width: '95%', // or you can use width: '100vw'
            height: 'auto', // or you can use height: '100vh'
          }}
          className="e-card-content e-card-separator"
        >
          {Object.hasOwn(props, 'associate') && (
            <TextBoxComponent
              value={`${props.associate.name} Risk: ${props.associate.risk}`}
              readOnly
              cssClass="e-small"
            />
          )}
          {((props.associate && props.associate && props.associate.hipaa && props.associate.hipaa.consent === true) || !props.associate.hipaa)
          && (
          <table className="card-template-wrap border-2 .kanbanZ" width="95%">
            <tbody>
              <tr>
                <td className="CardHeader1">Vital</td>
                <td>Reading</td>
                <td>Time</td>
              </tr>
              {props.associate && props.associate.oxygen && props.associate.oxygen.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">O₂</td>
                {props.associate.oxygen.alert && props.associate.oxygen.alert !== '' && (
                <td className="CardColumn kanbanZ">{props.associate.oxygen.reading}%</td>
                )}
                {(!props.associate.oxygen.alert || props.associate.oxygen.alert === '') && (
                <td className="kanbanZ">{props.associate.oxygen.reading}%</td>
                )}
                <td className="kanbanZ">{props.associate.oxygen.timestamp ? format(parseISO(props.associate.oxygen.timestamp), 'MM/dd hh:mm') : null}</td>
              </tr>
              )}
              {props.associate.temperature && props.associate.temperature.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">CBT</td>
                {props.associate.temperature.alert && props.associate.temperature.alert !== '' && (
                <td className="CardColumn kanbanZ">{props.associate.temperature.reading}°F</td>
                )}
                {(!props.associate.temperature.alert || props.associate.temperature.alert === '') && (
                <td className="kanbanZ">{props.associate.temperature.reading}°F</td>
                )}
                <td className="kanbanZ">{props.associate.temperature.timestamp ? format(parseISO(props.associate.temperature.timestamp), 'MM/dd hh:mm') : null }</td>
              </tr>
              )}
              {props.associate.heartrate && props.associate.heartrate.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">HR</td>
                {props.associate.heartrate.alert && props.associate.heartrate.alert !== '' && (
                <td className="CardColumn kanbanZ">{props.associate.heartrate.reading}<sup>bpm</sup></td>
                )}
                {(!props.associate.heartrate.alert || props.associate.heartrate.alert === '') && (
                <td className="kanbanZ">{props.associate.heartrate.reading}<sup>bpm</sup></td>
                )}
                <td className="kanbanZ">{props.associate.heartrate.timestamp ? format(parseISO(props.associate.heartrate.timestamp), 'MM/dd hh:mm') : '' }</td>
              </tr>
              )}
              {props.associate.hrv && props.associate.hrv.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">HRV</td>
                {props.associate.hrv.alert && props.associate.hrv.alert !== '' && (
                <td className="CardColumn kanbanZ">{props.associate.hrv.reading}<sub>ms</sub></td>
                )}
                {(!props.associate.hrv.alert || props.associate.hrv.alert === '') && (
                <td className="kanbanZ">{props.associate.hrv.reading}<sub>ms</sub></td>
                )}
                <td className="kanbanZ">{props.associate.hrv.timestamp ? format(parseISO(props.associate.hrv.timestamp), 'MM/dd hh:mm') : null }</td>
              </tr>
              )}
              {props.associate.hydration && props.associate.hydration.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">Hyd</td>
                {props.associate.hydration.alert && props.associate.hydration.alert !== '' && (
                <td className="CardColumn kanbanZ">{props.associate.hydration.reading}%</td>
                )}
                {(!props.associate.hydration.alert || props.associate.hydration.alert === '') && (
                <td className="kanbanZ">{props.associate.hydration.reading}%</td>
                )}
                <td className="kanbanZ">{props.associate.hydration.timestamp ? format(parseISO(props.associate.hydration.timestamp), 'MM/dd hh:mm') : null }</td>
              </tr>
              )}
              {props.associate.bloodpressure && props.associate.bloodpressure.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">BP</td>
                {props.associate.bloodpressure.alert && props.associate.bloodpressure.alert !== '' && (
                <td className="kanbanZ"><b>{props.associate.bloodpressure.reading}<sup>sys</sup><sub>dia</sub></b></td>
                )}
                {(!props.associate.bloodpressure.alert || props.associate.bloodpressure.alert === '') && (
                <td className="CardColumn kanbanZ">{props.associate.bloodpressure.reading}<sup>sys</sup><sub>dia</sub></td>
                )}
                <td className="kanbanZ">{props.associate.bloodpressure.timestamp ? format(parseISO(props.associate.bloodpressure.timestamp), 'MM/dd hh:mm') : null }</td>
              </tr>
              )}
              {props.associate.h2s && props.associate.h2s.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">H₂S</td>
                {props.associate.h2s.alert && props.associate.h2s.alert !== '' && (
                <td className="CardColumn kanbanZ">{Number(props.associate.h2s.reading).toFixed(3)}<sub>ppm</sub></td>
                )}
                {(!props.associate.h2s.alert || props.associate.h2s.alert === '') && (
                <td className="kanbanZ">{Number(props.associate.h2s.reading).toFixed(3)}<sub>ppm</sub></td>
                )}
                <td className="kanbanZ">{props.associate.h2s.timestamp ? format(parseISO(props.associate.h2s.timestamp), 'MM/dd hh:mm') : null }</td>
              </tr>
              )}
              {props.associate.respiratory && props.associate.respiratory.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">RRM</td>
                {props.associate.respiratory.alert && props.associate.respiratory.alert !== '' && (
                <td className="CardColumn kanbanZ">{props.associate.respiratory.reading}<sub><i>bpm</i></sub></td>
                )}
                {(!props.associate.respiratory.alert || props.associate.respiratory.alert === '') && (
                <td className="kanbanZ">{props.associate.respiratory.reading}<sub><i>bpm</i></sub></td>
                )}
                <td className="kanbanZ">{props.associate.respiratory.timestamp ? format(parseISO(props.associate.respiratory.timestamp), 'MM/dd hh:mm') : null }</td>
              </tr>
              )}
              {props.associate.fatigue && props.associate.fatigue.reading && (
              <tr className="kanbanZ">
                <td className="CardHeader kanbanZ">Exr</td>
                <td className="kanbanZ">{props.associate.fatigue.reading}</td>
                <td className="kanbanZ">{props.associate.fatigue.timestamp ? format(parseISO(props.associate.fatigue.timestamp), 'MM/dd hh:mm') : null }</td>
              </tr>
              )}
            </tbody>
          </table>
          )}
          {Object.hasOwn(props, 'associate') && props.associate.device && props.associate.device.length > 0 && (
          <TextBoxComponent
            value={`Device: ${props.associate.device}`}
            readOnly
            cssClass="e-small"
          />
          )}
          {Object.hasOwn(props, 'associate') && props.associate.resultField && props.associate.resultField[0] && (
          <TextBoxComponent
            value={`Battery: ${props.associate.resultField[0].battery}% ${props.associate.resultField[0].charger ? props.associate.resultField[0].charger.toUpperCase() : ''} \nMSN: ${props.associate.resultField[0].msn} \nH₂S ID: ${props.associate.resultField[0].h2s ? props.associate.resultField[0].h2s : ''}`}
            readOnly
            multiline
            rows={4}
            cssClass="e-small"
          />
          )}
          {Object.hasOwn(props, 'associate') && props.associate.resultField && props.associate.resultField[0] && props.associate.resultField[0].skinContact
            ? (
              <div>
                {/* <img src={compliance} width={30} /> */}
                Compliance:<SwitchComponent id="compliance" checked={props.associate.resultField[0].skinContact} cssClass="compliance-color" disabled />
              </div>
            ) : Object.hasOwn(props, 'associate') && props.associate.resultField && props.associate.resultField.skinContact ? (
              <div>
                {/* <img src={compliance} width={30} /> */}
                Compliance:<SwitchComponent id="compliance" checked={props.associate.resultField.skinContact} cssClass="compliance-color" disabled />
              </div>
            )
              : (
                <div>
                  {/* <img src={complianceOFF} width={30} /> */}
                  Compliance:<SwitchComponent id="compliance" checked={false} cssClass="compliance-color" disabled />
                </div>
              )}
          {Object.hasOwn(props, 'associate') && props.associate.resultField && props.associate.resultField.device && (
          <TextBoxComponent
            value={`Battery: ${props.associate.resultField.battery}% ${props.associate.resultField.charger.toUpperCase()} \nMSN: ${props.associate.resultField.msn} \nH₂S ID: ${props.associate.resultField.h2s ? props.associate.resultField.h2s : ''}`}
            readOnly
            multiline
            rows={3}
            cssClass="e-small"
          />
          )}
          {Object.hasOwn(props, 'associate') && props.associate.resultField && props.associate.resultField[0] && (
          <TextBoxComponent
            value={`TZ Offset: ${props.associate.resultField[0].tzoffset ? props.associate.resultField[0].tzoffset : ''}`}
            readOnly
            multiline
            rows={1}
            cssClass="e-small"
          />
          )}
        </div>
      </div>
    );
  }
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const searchClick = (e) => {
    const searchValue = e.value;
    let searchQuery = new Query();
    if (searchValue !== '') {
      searchQuery = new Query().search(searchValue, ['Id', 'associate.name'], 'contains', true);
    }
    kanbanObj.query = searchQuery;
  };
  const reset = () => {
    textBoxObj.value = '';
    kanbanObj.query = new Query();
  };

  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <div className="col-lg-12 control-section e-tab-section">
        <div className="e-sample-resize-container" />
        {changeAssociate === '' && (
        <div>
          <TextBoxComponent
            placeholder="Search..."
            ref={(obj) => { textBoxObj = obj; }}
            width="30%"
            change={searchClick}
          />
          <ButtonComponent type="button" id="reset" className="e-btn e-small e-outline e-info" onClick={reset}>Reset</ButtonComponent>

          <KanbanComponent
            cssClass="kanban-overview"
            id="kanban"
            keyField="status"
            dataSource={riskData}
            allowDragAndDrop={false}
            enablePersistence={false}
            // dialogOpen={cardClicked} // Attach the event handler here
            ref={(kanban) => { kanbanObj = kanban; }}
            cardSettings={{
              headerField: 'id',
              selectionType: 'None',
              contentField: 'organization',
              template: cardTemplate,
            }}
            sortSettings={{ sortBy: 'Custom', field: Number('risk'), direction: 'Descending' }}
            cardDoubleClick={cardClick}
          >
            <ColumnsDirective>
              <ColumnDirective
                headerText="HYPO"
                keyField="hypo"
                template={columnTemplate}
                allowToggle
                showAddButton={false}
              />
              <ColumnDirective
                headerText="BASELINE"
                keyField="baseline"
                template={columnTemplate}
                allowToggle
                isExpanded={false}
                showAddButton={false}
              />
              <ColumnDirective
                headerText="MODERATE"
                keyField="moderate"
                template={columnTemplate}
                allowToggle
                showAddButton={false}
              />
              <ColumnDirective
                headerText="ELEVATED"
                keyField="elevated"
                template={columnTemplate}
                allowToggle
                showAddButton={false}
              />
              <ColumnDirective
                headerText="SEVERE"
                keyField="severe"
                template={columnTemplate}
                allowToggle
                showAddButton={false}
              />
              <ColumnDirective
                headerText="NON REPORTING"
                keyField="nonreporting"
                template={columnTemplate}
                allowToggle
                isExpanded={false}
                showAddButton={false}
              />
            </ColumnsDirective>
          </KanbanComponent>
        </div>
        )}
      </div>
    </div>
  );
};
export default ReportCard;
